import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJpg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#7889A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.275 11.9C11.049 12.039 10.77 12.109 10.44 12.109C9.897 12.109 9.452 11.92 9.105 11.544C8.743 11.165 8.562 10.648 8.562 9.991C8.562 9.327 8.745 8.795 9.11 8.394C9.476 7.994 9.959 7.793 10.56 7.793C11.081 7.793 11.499 7.926 11.815 8.191C12.132 8.454 12.314 8.784 12.36 9.179H11.517C11.452 8.899 11.293 8.703 11.041 8.592C10.9 8.531 10.744 8.5 10.571 8.5C10.241 8.5 9.969 8.625 9.756 8.876C9.544 9.124 9.439 9.499 9.439 10C9.439 10.504 9.554 10.861 9.784 11.071C10.014 11.28 10.275 11.385 10.568 11.385C10.856 11.385 11.091 11.303 11.275 11.138C11.459 10.971 11.572 10.753 11.614 10.484H10.666V9.799H12.374V12H11.806L11.72 11.488C11.555 11.683 11.407 11.82 11.275 11.9Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.644 10.525H5.773V12H4.922V7.899H6.708C7.12 7.899 7.448 8.005 7.693 8.216C7.938 8.428 8.06 8.755 8.06 9.198C8.06 9.682 7.938 10.025 7.693 10.225C7.448 10.425 7.098 10.525 6.644 10.525ZM7.044 9.671C7.156 9.573 7.211 9.417 7.211 9.204C7.211 8.991 7.155 8.838 7.042 8.748C6.93 8.657 6.774 8.611 6.572 8.611H5.773V9.819H6.572C6.774 9.819 6.931 9.77 7.044 9.671Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.137 10.768V7.899H3.994V10.754C3.994 11.102 3.934 11.379 3.813 11.583C3.609 11.928 3.241 12.1 2.708 12.1C2.176 12.1 1.819 11.961 1.637 11.683C1.456 11.403 1.365 11.022 1.365 10.539V10.445H2.174V10.539C2.182 10.857 2.216 11.08 2.277 11.21C2.34 11.338 2.474 11.402 2.678 11.402C2.88 11.402 3.014 11.331 3.078 11.19C3.117 11.107 3.137 10.966 3.137 10.768Z",
			fill: "white"
		})
	]
});
export default SvgJpg;
